// extracted by mini-css-extract-plugin
export var container = "_ds-0";